import Svg, {
  Defs,
  Ellipse,
  G,
  Mask,
  Path,
  Polygon,
  Polyline,
  Use,
} from 'react-native-svg';

import React from 'react';

export default function house() {
  return (
    <Svg
      width="136px"
      height="114px"
      viewBox="0 0 136 114"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <Defs>
        <Path
          d="M0.0445242453,0.00303347857 C0.0298086049,0.00189592411 0.0150929645,0.00113755446 3.60822483e-15,-1.19348975e-15 C0.0147156404,0.00113755446 0.0298086049,0.00189592411 0.0445242453,0.00303347857 L0.0445242453,0.00303347857 Z"
          id="Path-1"
        />
      </Defs>
      <G
        id="img-create-household"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <G id="House-Vector">
          <Ellipse
            id="Oval"
            fill-opacity="0.10106739"
            fill="#263A43"
            cx="68"
            cy="104"
            rx="68"
            ry="10"
          />
          <G id="House" transform="translate(4.000000, 0.000000)">
            <Path
              d="M18.1974837,105.252606 L105.597905,105.252606 C107.807044,105.252606 109.597905,103.461745 109.597905,101.252606 L109.597905,36.3524488 L109.597905,36.3524488 L18.1974837,36.3524488 L18.1974837,105.252606 Z"
              id="Fill-3"
              fill="#92D0D4"
            />
            <Polyline
              id="Fill-4"
              fill="#92D0D4"
              points="18.2072687 36.3524488 109.439088 36.3524488 62.8736622 5.22744195 18.2072687 36.3524488"
            />
            <Path
              d="M102.677314,83.6610639 L102.677314,51.4057071 L74.3769944,51.4057071 L74.3769944,80.9514092 C72.0688764,80.1683925 69.8337691,79.2155011 67.6852209,78.0677086 C65.7372641,77.0260879 63.9695761,75.850615 62.386673,74.5655576 L62.386673,49.1059511 L53.2622115,49.1059511 C54.0431254,45.5950789 55.4540393,42.1482888 57.2646305,38.8990541 C57.7452218,38.037167 58.2690928,37.1889306 58.8287164,36.3524488 L94.0010786,36.3524488 L109.439088,46.6715846 L109.439088,80.9866734 C108.920109,81.365479 108.437636,81.8489397 108.031561,82.4632191 C106.294733,83.014933 104.509733,83.4032182 102.677314,83.6610639"
              id="Fill-5"
              fill="#BEE1DF"
            />
            <Path
              d="M94.0010786,36.3524488 L58.8287164,36.3524488 C61.1628022,32.8654652 64.1238771,29.5919627 67.2091457,26.4488997 C68.7845218,24.8438103 70.4716722,23.2990114 72.2852742,21.8372539 L94.0010786,36.3524488"
              id="Fill-6"
              fill="#BEE1DF"
            />
            <Path
              d="M74.3769944,98.5008411 L38.2987721,98.5008411 C38.4764065,98.3582676 38.6879118,98.1588164 38.9092021,97.9506439 C39.0947398,97.7747022 39.2862989,97.5934518 39.4962989,97.4099264 C41.1251159,95.4840467 41.1589869,93.0470258 39.5979118,90.1610501 C39.5967827,90.1610501 38.483557,88.2556464 36.6733421,87.3656996 L60.5685549,87.3656996 C61.5274795,87.7729441 62.5055977,88.1589543 63.5017804,88.5237301 C66.9521027,89.7856572 70.6094141,90.7438572 74.3769944,91.4385238 L74.3769944,98.5008411 M32.0454394,87.5522586 C31.7549018,87.5522586 31.4651168,87.4896931 31.1960308,87.3656996 L32.8948479,87.3656996 C32.8888264,87.3683539 32.8828049,87.3710082 32.8767834,87.3736625 C32.6118372,87.4931057 32.3284501,87.5522586 32.0454394,87.5522586 M18.1974837,81.4227359 L18.1974837,42.6768725 L18.4353332,42.5111687 L18.4353332,47.7389899 L34.7743101,36.3524488 L39.5768365,36.3524488 C38.2061915,39.1690337 37.1162991,42.0709351 36.3534497,45.0672536 C36.0147401,46.4004674 35.744525,47.7492278 35.5488261,49.1059511 L24.2005477,49.1059511 L24.2005477,79.6788649 C24.1986659,79.6788649 24.1967842,79.6788649 24.1952788,79.6784857 C24.1945261,79.6784857 24.1937735,79.6784857 24.1930208,79.6784857 C24.1885046,79.6781066 24.1839885,79.6777274 24.1794724,79.6773482 C24.179096,79.6773482 24.179096,79.6773482 24.1787197,79.6773482 C24.1693111,79.6765898 24.1595262,79.6758314 24.1501176,79.6750731 C24.1493649,79.6750731 24.1493649,79.6750731 24.1489885,79.6750731 C24.144096,79.6746939 24.1395799,79.6743147 24.1346874,79.6739355 C24.1343111,79.6739355 24.1339348,79.6739355 24.1339348,79.6739355 C24.1192573,79.672798 24.1042036,79.6720396 24.0895262,79.670902 L24.0887735,79.670902 C24.0842573,79.6705229 24.0789885,79.6701437 24.0744724,79.6701437 L24.0737197,79.6701437 C24.0639348,79.6693853 24.0537735,79.6686269 24.0439885,79.6682478 L24.0436122,79.6682478 C24.0390961,79.6678686 24.0338272,79.6674894 24.0293111,79.6674894 L24.0281821,79.6671102 C24.0232896,79.6671102 24.0183971,79.666731 24.0135047,79.6663518 L24.0131283,79.6663518 C24.0033434,79.6659726 23.9935584,79.6652143 23.9833971,79.6648351 C23.9833971,79.6648351 23.9830208,79.6648351 23.9826444,79.6648351 C23.977752,79.6644559 23.9728595,79.6644559 23.967967,79.6640767 L23.9675907,79.6640767 C23.9623219,79.6636975 23.9578057,79.6636975 23.9525369,79.6633183 C23.9423756,79.6629392 23.9325907,79.66256 23.9224294,79.6621808 C23.9216767,79.6621808 23.9220531,79.6621808 23.9213004,79.6621808 C23.9164079,79.6618016 23.9115154,79.6614224 23.906623,79.6614224 L23.9062466,79.6614224 C23.895709,79.6610432 23.885924,79.6606641 23.8757627,79.6602849 L23.8753864,79.6602849 C23.8704939,79.6599057 23.8659778,79.6599057 23.860709,79.6595265 C23.8603326,79.6595265 23.8603326,79.6595265 23.8595799,79.6595265 C23.8546875,79.6595265 23.849795,79.6591473 23.8449025,79.6591473 L23.8441498,79.6591473 C23.8339885,79.6587681 23.8245799,79.6583889 23.8144187,79.6583889 C23.8140423,79.6583889 23.813666,79.6583889 23.8132896,79.6583889 C23.8083972,79.6580098 23.8035047,79.6580098 23.7989886,79.6580098 C23.7982359,79.6580098 23.7978595,79.6576306 23.7971068,79.6576306 C23.7922144,79.6576306 23.7876982,79.6576306 23.7828058,79.6572514 C23.7824294,79.6572514 23.7824294,79.6572514 23.7820531,79.6572514 C23.7722681,79.6572514 23.7621068,79.6568722 23.7523219,79.6568722 C23.7515692,79.6568722 23.7511929,79.6568722 23.7508165,79.6568722 C23.745924,79.656493 23.7414079,79.656493 23.7368918,79.656493 C23.7361391,79.656493 23.7350101,79.656493 23.7346337,79.656493 C23.7297412,79.656493 23.7248488,79.6561138 23.7203326,79.6561138 L23.71958,79.6561138 C23.7146875,79.6561138 23.709795,79.6561138 23.7049025,79.6561138 C23.7045262,79.6561138 23.7041499,79.6561138 23.7041499,79.6561138 C23.6992574,79.6557347 23.6943649,79.6557347 23.6898488,79.6557347 C23.6890961,79.6557347 23.6883434,79.6557347 23.6875907,79.6557347 C23.6826982,79.6557347 23.6785585,79.6557347 23.6740423,79.6557347 C23.6729133,79.6557347 23.6721606,79.6557347 23.6710316,79.6557347 C23.6665154,79.6553555 23.661623,79.6553555 23.6571068,79.6553555 C23.6522144,79.6553555 23.6473219,79.6553555 23.6424294,79.6553555 C23.6416767,79.6553555 23.6413004,79.6553555 23.6405477,79.6553555 C23.6360316,79.6553555 23.6315155,79.6553555 23.626623,79.6553555 C23.6262466,79.6553555 23.6247413,79.6553555 23.6239886,79.6553555 C23.6194724,79.6553555 23.6149563,79.6553555 23.6104402,79.6553555 C23.6096875,79.6553555 23.6089348,79.6553555 23.6081821,79.6553555 C23.6032896,79.6553555 23.5983972,79.6553555 23.5935047,79.6553555 C23.5509778,79.6553555 23.5001714,79.6530804 23.4576445,79.6500469 C23.4482359,79.6500469 23.3880209,79.6477718 23.2943112,79.6477718 C22.0493651,79.6477718 19.8398491,79.8934835 18.1974837,81.4227359"
              id="Fill-7"
              fill="#88BEC2"
            />
            <Path
              d="M39.5768365,36.3524488 L34.7743101,36.3524488 L42.6647394,30.8542689 C41.5202772,32.6519842 40.4868364,34.4830677 39.5768365,36.3524488"
              id="Fill-8"
              fill="#88BEC2"
            />
            <Path
              d="M18.1974837,105.252606 L105.597905,105.252606 C107.807044,105.252606 109.597905,103.461745 109.597905,101.252606 L109.597905,98.5008411 L109.597905,98.5008411 L18.1974837,98.5008411 L18.1974837,105.252606 Z"
              id="Fill-9"
              fill="#02A6B6"
            />
            <Polyline
              id="Fill-10"
              fill="#6D9A9E"
              points="109.597905 46.7777563 109.439088 46.6715846 109.439088 41.4433843 109.597905 41.549556 109.597905 46.7777563"
            />
            <Path
              d="M42.6647394,30.8542689 C44.9205457,27.3096492 47.6065131,23.8981234 50.6191473,20.596182 C51.0748999,20.0964164 51.5370504,19.6038553 52.0059751,19.1166028 L63.7704901,10.9178686 L75.8432308,18.9873008 C75.1932847,19.5166428 74.6110804,20.0554644 74.115059,20.4232737 C73.4910805,20.8851208 72.8814032,21.3568267 72.2852742,21.8372539 L63.7704901,16.1456897 L42.6647394,30.8542689"
              id="Fill-11"
              fill="#6D9A9E"
            />
            <Polyline
              id="Fill-12"
              fill="#8CA5A5"
              points="109.439088 46.6715846 94.0010786 36.3524488 101.822637 36.3524488 109.439088 41.4433843 109.439088 46.6715846"
            />
            <Path
              d="M101.822637,36.3524488 L94.0010786,36.3524488 L72.2852742,21.8372539 C72.8814032,21.3568267 73.4910805,20.8851208 74.115059,20.4232737 C74.6110804,20.0554644 75.1932847,19.5166428 75.8432308,18.9873008 L101.822637,36.3524488"
              id="Fill-13"
              fill="#8CA5A5"
            />
            <Polyline
              id="Fill-14"
              fill="#648D90"
              points="18.4353332 47.7389899 18.4353332 42.5111687 27.2726441 36.3524488 34.7743101 36.3524488 18.4353332 47.7389899"
            />
            <Path
              d="M34.7743101,36.3524488 L27.2726441,36.3524488 L52.0059751,19.1166028 C51.5370504,19.6038553 51.0748999,20.0964164 50.6191473,20.596182 C47.6065131,23.8981234 44.9205457,27.3096492 42.6647394,30.8542689 L34.7743101,36.3524488"
              id="Fill-15"
              fill="#648D90"
            />
            <Path
              d="M118.033743,46.2567325 L124.12834,44.2231571 C125.176121,43.8735454 125.742099,42.7407346 125.392487,41.6929534 C125.252043,41.2720448 124.975614,40.9097918 124.606712,40.6632158 L75.6869874,7.9650427 C68.4999132,3.1611686 59.1033239,3.25238225 52.0108586,8.19486931 L5.3808969,40.6896328 C4.47466537,41.3211533 4.25196813,42.5677477 4.88348868,43.4739792 C5.12461154,43.8199903 5.46894311,44.0809233 5.86727044,44.2194848 L11.651974,46.2317421 C12.2572566,46.4422947 12.9267801,46.3500374 13.4525603,45.9836296 L63.7704901,10.9178686 L63.7704901,10.9178686 L116.289301,46.0223132 C116.803295,46.3658753 117.447285,46.4524151 118.033743,46.2567325 Z"
              id="Fill-16"
              fill="#76453A"
            />
            <Path
              d="M2.29732396,42.8384052 L2.29732396,42.8384052 L63.7704901,0 L2.29732396,42.8384052 M127.773817,42.7803899 L63.7704901,0 L127.77457,42.7803899 L127.773817,42.7803899"
              id="Fill-17"
              fill="#9E9F9E"
            />
            <Path
              d="M63.6440385,5.56719155 L7.54356001,44.6626634 L6.00141856,44.1263806 C4.95813222,43.7635757 4.40649303,42.6237136 4.76929793,41.5804272 C4.90784242,41.182027 5.16879967,40.8376286 5.51486221,40.5964688 L62.6505208,0.780470489 C63.3259957,0.309753816 64.2209136,0.30106705 64.9053986,0.758582901 L124.380491,40.5122604 C125.298809,41.1260725 125.54566,42.3681096 124.931848,43.2864279 C124.685267,43.6553353 124.323005,43.9317663 123.902088,44.0722069 L122.13242,44.6626634 L122.13242,44.6626634 L63.6440385,5.56719155 Z"
              id="Fill-18"
              fill="#4E2E26"
            />
            <Path
              d="M76.7795748,101.655659 L100.27511,101.655659 L100.27511,55.0026543 L76.7795748,55.0026543 L76.7795748,101.655659 Z M74.3769944,105.252606 L102.677314,105.252606 L102.677314,51.4057071 L74.3769944,51.4057071 L74.3769944,105.252606 Z"
              id="Fill-19"
              fill="#76453A"
            />
            <Path
              d="M90.7133369,105.252606 L74.3769944,105.252606 L74.3769944,51.4057071 L102.677314,51.4057071 L102.677314,88.7038429 C102.446239,88.6810918 102.194089,88.6666828 101.927261,88.6666828 C101.699949,88.6666828 101.477906,88.6769207 101.260003,88.6970175 L101.260003,53.6626151 L75.332532,53.6626151 L75.332532,102.99494 L91.6338745,102.99494 C91.4968852,103.122725 91.3730681,103.259231 91.2650573,103.405976 C90.8992509,103.90195 90.715595,104.513196 90.7133369,105.252606"
              id="Fill-20"
              fill="#291D1A"
            />
            <Polygon
              id="Fill-21"
              fill="#452821"
              points="76.7795748 101.655659 100.27511 101.655659 100.27511 55.0026543 76.7795748 55.0026543"
            />
            <Path
              d="M84.0896817,101.655659 L76.7795748,101.655659 L76.7795748,55.0026543 L100.27511,55.0026543 L100.27511,58.3254509 C99.0090888,58.3948417 97.7370459,58.6265236 96.4913471,58.9067412 C93.5438205,59.5706938 90.6730681,61.0832621 88.2836597,63.4660595 C83.9252193,67.814551 81.9125313,75.5783603 81.2031228,82.4810408 C80.5336067,88.9927817 81.176026,96.1734047 84.0896817,101.655659"
              id="Fill-22"
              fill="#3A211B"
            />
            <Path
              d="M98.627476,78.4396889 C98.627476,79.705787 97.6700567,80.7329987 96.4905944,80.7329987 C95.3088741,80.7329987 94.3533366,79.705787 94.3533366,78.4396889 C94.3533366,77.1724533 95.3088741,76.1467583 96.4905944,76.1467583 C97.6700567,76.1467583 98.627476,77.1724533 98.627476,78.4396889"
              id="Fill-23"
              fill="#F1A948"
            />
            <Polygon
              id="Fill-24"
              fill="#3F241E"
              points="24.2005477 87.3656996 62.386673 87.3656996 62.386673 49.1059511 24.2005477 49.1059511"
            />
            <Polygon
              id="Fill-25"
              fill="#21170F"
              points="27.0724291 84.488066 59.5147916 84.488066 59.5147916 51.9832056 27.0724291 51.9832056"
            />
            <Polygon
              id="Fill-26"
              fill="#65B7B1"
              points="28.8736117 67.3326071 42.1096319 67.3326071 42.1096319 54.0725139 28.8736117 54.0725139"
            />
            <Polygon
              id="Fill-27"
              fill="#65B7B1"
              points="44.4896317 67.3326071 57.7260283 67.3326071 57.7260283 54.0725139 44.4896317 54.0725139"
            />
            <Polygon
              id="Fill-28"
              fill="#65B7B1"
              points="28.8675902 82.399516 42.1039868 82.399516 42.1039868 69.1382853 28.8675902 69.1382853"
            />
            <Polygon
              id="Fill-29"
              fill="#65B7B1"
              points="44.4832339 82.399516 57.7196304 82.399516 57.7196304 69.1382853 44.4832339 69.1382853"
            />
            <Polyline
              id="Fill-30"
              fill="#A0C9C2"
              points="28.8736117 55.0314723 42.1039868 60.7029397 42.1039868 61.2387279 28.8736117 55.6518187 28.8736117 55.0314723"
            />
            <Polyline
              id="Fill-31"
              fill="#A0C9C2"
              points="42.1096319 61.7324265 42.1096319 62.2970327 28.8675902 56.8940282 28.8675902 56.2441054 42.1096319 61.7324265"
            />
            <Polyline
              id="Fill-32"
              fill="#A0C9C2"
              points="28.8675902 57.3733178 42.1096319 62.8460923 42.1096319 63.3826389 28.8736117 57.9936642 28.8675902 57.3733178"
            />
            <Polyline
              id="Fill-33"
              fill="#A0C9C2"
              points="28.8736117 72.1292951 42.1039868 77.799625 42.1039868 78.3369298 28.8736117 72.7496415 28.8736117 72.1292951"
            />
            <Polyline
              id="Fill-34"
              fill="#A0C9C2"
              points="42.1096319 78.8302493 42.1096319 79.3948555 28.8675902 73.9907134 28.8675902 73.3423074 42.1096319 78.8302493"
            />
            <Polyline
              id="Fill-35"
              fill="#A0C9C2"
              points="28.8675902 74.4715198 42.1096319 79.9442943 42.1096319 80.4804616 28.8736117 75.0918661 28.8675902 74.4715198"
            />
            <Polyline
              id="Fill-36"
              fill="#A0C9C2"
              points="44.4926425 71.5927486 57.7222648 77.2645952 57.7222648 77.8007625 44.4926425 72.2138533 44.4926425 71.5927486"
            />
            <Polyline
              id="Fill-37"
              fill="#A0C9C2"
              points="57.7286627 78.2948403 57.7286627 78.858309 44.4869973 73.4556836 44.4869973 72.80614 57.7286627 78.2948403"
            />
            <Polyline
              id="Fill-38"
              fill="#A0C9C2"
              points="44.4869973 73.9357316 57.7286627 79.408127 57.7286627 79.9442943 44.4926425 74.5553196 44.4869973 73.9357316"
            />
            <Polyline
              id="Fill-39"
              fill="#A0C9C2"
              points="44.4930188 57.0627654 57.7222648 62.734612 57.7222648 63.2704001 44.4930188 57.6838702 44.4930188 57.0627654"
            />
            <Polyline
              id="Fill-40"
              fill="#A0C9C2"
              points="57.7286627 63.7637196 57.7286627 64.3283258 44.4869973 58.9249421 44.4869973 58.2761569 57.7286627 63.7637196"
            />
            <Polyline
              id="Fill-41"
              fill="#A0C9C2"
              points="44.4869973 59.4049901 57.7286627 64.8777646 57.7286627 65.4143111 44.4930188 60.0253364 44.4869973 59.4049901"
            />
            <Path
              d="M0.338829527,107.261906 C0.466786504,107.63692 1.44490469,110 5.65393654,110 L5.6561946,110 C6.21657089,110 6.82060309,109.95829 7.449474,109.872973 C7.5382912,109.861218 7.62936646,109.854014 7.71893634,109.854014 L42.6222125,109.854014 C43.8931264,109.854014 45.6562983,109.201058 46.9125347,108.26485 C48.5763518,107.024537 48.6749539,104.78583 48.0359217,103.117416 C47.2982874,101.194191 45.6209219,99.7984116 44.0462984,99.7984116 C43.6131264,99.7984116 43.1758146,99.901929 42.7494168,100.107447 C42.6286104,100.165462 42.498019,100.249262 42.3440943,100.373256 C41.6226427,101.162339 40.9030729,101.708366 40.4145783,102.033327 C40.2587719,102.142153 40.0660838,102.2597 39.8741483,102.361322 L39.8335031,102.382935 C38.8343097,102.886114 37.6187184,102.486074 37.1068905,101.485026 C36.5961916,100.483219 36.9793099,99.253523 37.9664603,98.7264561 C37.9822668,98.7177348 38.0571592,98.6733702 38.166299,98.6009459 C38.3657613,98.4625434 38.6295785,98.213419 38.9092021,97.9506439 C39.0947398,97.7747022 39.2862989,97.5934518 39.4962989,97.4099264 C41.1251159,95.4840467 41.1589869,93.0470258 39.5979118,90.1610501 C39.5964064,90.1610501 37.7018904,86.9175032 34.8360305,86.9175032 C34.210923,86.9175032 33.5511919,87.0714522 32.8767834,87.3736625 C32.2885576,87.6387127 31.6092566,87.6076195 31.0466223,87.2891043 C30.4839879,86.9713474 30.1042568,86.4037077 30.0222138,85.7594727 C29.93716,85.1440558 29.0192569,79.6553555 23.5935047,79.6553555 C23.5509778,79.6553555 23.5001714,79.6530804 23.4576445,79.6500469 C23.4482359,79.6500469 23.3880209,79.6477718 23.2943112,79.6477718 C21.157806,79.6477718 16.1791506,80.3712564 16.1046345,87.066902 C16.0978603,87.7327505 15.7711936,88.3527177 15.2285055,88.7337985 C14.6873228,89.1129833 13.9959787,89.2055044 13.373882,88.9787519 C13.3731293,88.9787519 12.4540972,88.6666828 11.2140435,88.6666828 C8.89275343,88.6666828 7.06485038,89.725746 5.77813008,91.8135376 C5.50678602,92.3330208 4.37925924,94.9983109 7.88753848,97.6575341 C8.59845239,98.1963557 8.88146311,99.1374924 8.584904,99.9838329 C8.29060295,100.829415 7.49463529,101.383025 6.59479666,101.355724 L6.49054936,101.354207 C4.8470549,101.354207 1.74710896,101.786478 0.551840259,103.405976 C-0.101116667,104.291373 -0.174127413,105.543441 0.330173614,107.234605 L0.334689742,107.247877 L0.335066086,107.253185 L0.338829527,107.261906"
              id="Fill-42"
              fill="#68893D"
            />
            <G id="Group-45" transform="translate(24.089526, 79.670902)">
              <Mask id="Mask-2" fill="white">
                <Use xlinkHref="#Path-1" />
              </Mask>
              <G id="Clip-44" />
              <Polygon
                id="Fill-43"
                fill="#648D90"
                mask="url(#Mask-2)"
                points="-0.496021457 0.00796288125 0.110645151 0.00796288125 0.110645151 -0.0155465777 -0.496021457 -0.0155465777"
              />
            </G>
          </G>
        </G>
      </G>
    </Svg>
  );
}
